export default {
  "orderTask.title": "【一键下单】我的下单任务",
  "orderTask.projectOrderTask": "工程下单任务",
  "orderTask.factoryOrder": "工厂订单",
  "orderTask.search": "搜索",
  "orderTask.operate": "操作",
  "orderTask.taskCreationTime": "任务创建时间",
  "orderTask.taskEndTime": "任务结束时间",
  "orderTask.taskStatus": "任务状态",
  "orderTask.edit": "编辑",
  "orderTask.splitOrderDetails": "拆单详情",
  "orderTask.oneClickOrder": "一键下单",
  "orderTask.delete": "删除",
  "orderTask.reassign": "转派",
  "orderTask.associatedSourceFile": "关联源文件",
  "orderTask.masterContractNumber": "主合同号",
  "orderTask.orderTaskId": "下单任务ID",
  "orderTask.remarks": "备注说明",
  "orderTask.completedTotal": "拆单完成数/拆单总数",
  "orderTask.currentResponsible": "当前责任人",
  "orderTask.splitOrderDetails": "拆单详情",
  "orderTask.fullOrderSplitting": "全量拆单",
  "orderTask.simpleOrderSplitting": "简易拆单",
  "orderTask.NO": "序号",
  "orderTask.cancel": "取消拆单",
  "orderTask.redo": "重拆",
  "orderTask.affiliated": "所属组合柜",
  "orderTask.taskId": "任务ID",
  "orderTask.orderName": "合同自编号",
  "orderTask.taskType": "任务类型",
  "orderTask.splitDocument": "拆单文件",
  "orderTask.showMore": "展示更多",
  "orderTask.fold": "收起",
  "orderTask.taskCreator": "任务创建人",
  "orderTask.saved": "已保存",
  "orderTask.splittingTheOrder": "拆单中",
  "orderTask.successfullySplit": "拆单成功",
  "orderTask.failedSplit": "拆单失败",
  "orderTask.ordered": "已下单",
  "orderTask.FailedOrder": "下单失败",
  "orderTask.placingOrder": "下单中",
  "orderTask.canceled": "已取消",
  "orderTask.yes": "确定",
  "orderTask.cancel": "取消",
  "orderTask.save": "保存",
  "orderTask.mtdsFactoryOrder": "MTDS工厂订单",
  "orderTask.orderNumber": "订单编号",
};



// WEBPACK FOOTER //
// ./src/locales/lang/zh-CN/orderTask/settings.js